import React, { SVGProps } from "react";
import styled from "styled-components";

const StyledSVG = styled.svg(({ style }) => ({ fill: "currentColor", ...style }));

export const Svg: React.FC<Omit<SVGProps<Element>, "ref">> = ({ children, ...props }) => (
  <StyledSVG {...props}>{children}</StyledSVG>
);
